export default __webpack_public_path__ + "static/media/01.9f53b421.jpg";